import type {ExactUserRawBodyMailSendRequest, RawBodyMailSendRequest} from 'typings/portaro.be.types';
import type {MailerDataService} from 'shared/mailer/mailer-data.service';
import type FinishedResponseInteractionService from 'shared/services/finished-response-interaction.service';

export class MailerService {
    public static serviceName = 'mailerService';

    /*@ngInject*/
    constructor(private mailerDataService: MailerDataService,
                private finishedResponseInteractionService: FinishedResponseInteractionService) {
    }

    public async sendMailToExactUsers(request: ExactUserRawBodyMailSendRequest): Promise<void> {
        try {
            const actionResponse = await this.mailerDataService.sendMailToExactUsers(request);
            return this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }

    public async sendMail(request: RawBodyMailSendRequest): Promise<void> {
        try {
            const actionResponse = await this.mailerDataService.sendMail(request);
            return this.finishedResponseInteractionService.showSuccessResponseInToastIfPossible(actionResponse);
        } catch (exceptionResponse) {
            await this.finishedResponseInteractionService.showFailedResponseInModalWindow(exceptionResponse);
            throw exceptionResponse;
        }
    }
}
